import React, { useState } from 'react';
import {
  AppBar, Toolbar, Typography, IconButton, Menu, MenuItem,
  Box, Tooltip, Drawer, List, ListItem, ListItemText
} from '@mui/material';
import {
  AccountCircle, Brightness4, Brightness7, Menu as MenuIcon
} from '@mui/icons-material';
import '../css/App.css';
import LogoutIcon from '@mui/icons-material/Logout';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

function Header({ firmName, logoUrl, username, menuItems = [], onMenuSelect, drawerOpen, setDrawerOpen, darkMode, setDarkMode }) {
  const [anchorEl, setAnchorEl] = useState(null);
  //const [darkMode, setDarkMode] = useState(false);
  //const [drawerOpen, setDrawerOpen] = useState(false);
const [expandedMenu, setExpandedMenu] = useState(null); // or useState('Reports') to default open

  const handleMenuOpen = (e) => setAnchorEl(e.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);
  const toggleDrawer = (open) => () => setDrawerOpen(open);
const [reportsExpanded, setReportsExpanded] = useState(false);
  const handleMenuClick = (item) => {
    onMenuSelect(item);
    setDrawerOpen(false);
  };

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: '#000', color: '#fff' }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>

          <Box display="flex" alignItems="flex-end">
            {/* Logo hidden on extra-small screens */}
            {logoUrl && (
              <Box
                component="img"
                src={logoUrl}
                alt="Logo"
                sx={{
                  height: 35,
                  marginRight: 2,
                  display: { xs: 'none', sm: 'block' } // Hide on xs (mobile)
                }}
              />
            )}
            <Typography
              variant="h6"
              sx={{
                fontSize: { xs: '1rem', sm: '1.5rem' }, // Smaller on mobile
                fontWeight: 600
              }}
            >
              {firmName}
            </Typography>
          </Box>

          {/* Right: Dark Mode + User */}
          <Box display="flex" alignItems="center">
            <Tooltip title={darkMode ? 'Light Mode' : 'Dark Mode'}>
              <IconButton color="inherit" onClick={() => {
                setDarkMode(!darkMode);
                document.body.classList.toggle('dark-theme');
              }}>
                {darkMode ? <Brightness7 /> : <Brightness4 />}
              </IconButton>
            </Tooltip>
            <Tooltip title={username}>
              <IconButton color="inherit" onClick={handleMenuOpen}><AccountCircle sx={{ color: '#ffea00' }}/></IconButton>
            </Tooltip>


            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              MenuListProps={{
                sx: {
                  backgroundColor: '#1e1e2f',
                  color: '#fff',
                  '& .MuiMenuItem-root:not(.logout-item)': {
                    '&:hover': {
                      backgroundColor: '#3445ff', // default hover color
                    },
                  },
                },
              }}
            >
              <MenuItem
                onClick={() => {
                  alert('User Details');
                  handleMenuClose();
                }}
              >
                <AccountBoxIcon sx={{ mr: 1, fontSize: '1.2rem', color: 'red' }}/>
                User Details
              </MenuItem>
              <MenuItem
                onClick={() => {
                  alert('Settings');
                  handleMenuClose();
                }}
              >
                 <ManageAccountsIcon sx={{ mr: 1, fontSize: '1.2rem', color: 'blue' }}/>
                User Settings
              </MenuItem>
             
 {/* <MenuItem
                className="logout-item"
                onClick={() => {
                  localStorage.clear();
                  window.location.href = '/';
                }}
                sx={{
                  '&.logout-item:hover': {
                    backgroundColor: '#ff4d4f', // red hover for Logout
                  },
                }}
              >
                 <LogoutIcon sx={{ mr: 1, fontSize: '1.2rem', color: 'green' }} />
                Logout
              </MenuItem> */}




            </Menu>


            <Tooltip title={'Select Menu'}>
              <IconButton color="inherit" onClick={toggleDrawer(true)} sx={{ mr: 1 }}>
                <MenuIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            top: { xs: '56px', sm: '72px' },
            //  height: 'calc(100% - 72px)',
            maxHeight: 'auto', // Let it grow based on content
            backgroundColor: '#1e1e2f',
            color: '#fff'

          },
        }}
      >
        <Box
          sx={{
            width: { xs: '75%', sm: 250 }, // 50% width on mobile, 250px on larger screens
            pr: '20px',
            backgroundColor: '#1e1e2f', // dark background
            color: '#ffffff', // text color
          }}
          role="presentation"
        >
        
<List>
  {menuItems.map((item) => (
    <React.Fragment key={item.label}>
      <ListItem
        button
        onClick={() => {
          if (item.children) {
            setExpandedMenu(expandedMenu === item.label ? null : item.label);
          } else {
            handleMenuClick(item.label);
          }
        }}
        sx={{
          '&:hover': { backgroundColor: '#3445ff' },
          py: 0.5,
        }}
      >
        {item.icon && <Box sx={{ mr: 1 }}>{item.icon}</Box>}
        <ListItemText
          primary={item.label}
          primaryTypographyProps={{
            sx: { fontSize: { xs: '0.7rem', sm: '1rem' }, color: '#fff' },
          }}
        />
        {item.children &&
          (expandedMenu === item.label ? (
            <ExpandLessIcon sx={{ color: '#fff' }} />
          ) : (
            <ExpandMoreIcon sx={{ color: '#fff' }} />
          ))}
      </ListItem>

      {/* Submenu (shown only when expanded) */}
      {item.children &&
        expandedMenu === item.label &&
        item.children.map((subItem) => (
          <ListItem
            key={subItem.label}
            button
            onClick={() => handleMenuClick(subItem.label)}
            sx={{
              pl: 4,
              '&:hover': { backgroundColor: '#3445ff' },
              py: 0.5,
            }}
          >
            {subItem.icon && <Box sx={{ mr: 1 }}>{subItem.icon}</Box>}
            <ListItemText
              primary={subItem.label}
              primaryTypographyProps={{
                sx: { fontSize: { xs: '0.7rem', sm: '1rem' }, color: '#fff' },
              }}
            />
          </ListItem>
        ))}
    </React.Fragment>
  ))}

  {/* Logout Item */}
  <ListItem
    button
    onClick={() => {
      localStorage.clear();
      window.location.href = '/';
    }}
    sx={{
      '&:hover': { backgroundColor: '#ff4d4f' },
      py: 0.5,
    }}
  >
    <LogoutIcon sx={{ mr: 1, fontSize: '1.2rem', color: '#fff' }} />
    <ListItemText
      primary="Logout"
      primaryTypographyProps={{
        sx: { fontSize: { xs: '0.7rem', sm: '1rem' }, color: '#fff' },
      }}
    />
  </ListItem>
</List>







        </Box>

      </Drawer>
    </>
  );
}

export default Header;
